// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-highlight__middle__toggler{text-align:right}.new-highlight__body{position:relative}.new-highlight__add:hover,.new-highlight__clear:hover{color:#1667b8;color:var(--status-info-hover)}.new-highlight__add svg,.new-highlight__clear svg{color:#1976d2!important}.new-highlight__disabled{opacity:.5;cursor:not-allowed}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
